export default __webpack_public_path__ + "static/media/cbe.3d1def6c.png";